import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=cd0ba5c2&scoped=true"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"
import style0 from "./Transaction.vue?vue&type=style&index=0&id=cd0ba5c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0ba5c2",
  null
  
)

export default component.exports